import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import authHeader from "./auth-header";

// Get column order size columns
export const fetchColumnOrderSizeColumns = () => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/szgrpdtl/column-order-sizes`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

// Get all size group details
export const fetchAllSzGrpDtls = (filters = {}) => {
  let queryArr = [];
  for (let key in filters) {
    if (filters[key] !== "") {
      queryArr.push(`${key}=${encodeURIComponent(filters[key])}`);
    }
  }
  let url = "?" + queryArr.join("&");
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/szgrpdtl${url}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

// Get one size group detail
export const fetchOneSzGrpDtl = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/szgrpdtl/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

// Create size group detail
export const createSzGrpDtl = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/szgrpdtl/`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

// Update size group detail
export const updateSzGrpDtl = ({ id, data }) => {
  return axios
    .put(`${process.env.REACT_APP_BASE_URL}/szgrpdtl/${id}`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

// Delete size group detail
export const deleteSzGrpDtl = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_BASE_URL}/szgrpdtl/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};
